<template>
  <div class="gallery-converter-info w-full">
    <section class="relative flexing w-full h-full">
      <div class="info-wrapper flexing flex-col">
        <p class="info-text text-28 text-texts-standard-default mb-3">
          {{ $t('gallery.conversionRate') }}
        </p>

        <div
          class="info-box text-36 text-texts-standard-default font-bold flexing"
          :class="$isSsm ? 'revert-skew' : 'skew'"
        >
          <section class="flexing w-full" :class="{ 'revert-skew': $isWsm }">
            <span class="mr-2">{{ conversionRate }}</span>
            <app-main-icon :icon-size="48" :icon-name="`puzzle-${conversionTypeFrom}`" />
            <span class="mx-2">=</span>
            <span class="mr-2">1</span>
            <app-main-icon :icon-size="48" :icon-name="`puzzle-${conversionTypeTo}`" />
          </section>
        </div>
      </div>

      <div class="gallery-converter-info-divider" />

      <div class="info-wrapper flexing flex-col">
        <p class="info-text text-28 text-texts-standard-default mb-3">
          {{ $t('gallery.timePerPiece') }}
        </p>

        <div
          class="info-box flexing text-36 text-texts-standard-default font-bold"
          :class="$isSsm ? 'revert-skew' : 'skew'"
        >
          <section class="flexing w-full" :class="{ 'revert-skew': $isWsm }">
            <app-icon class="clubs-employees-box-footer-valid-icon" icon-name="time" />
            <span class="ml-3">{{ `${conversionDuration / 60 / 60}h` }}</span>
          </section>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'GalleryConverterHeader',

  props: {
    conversionTypeFrom: {
      type: String,
      required: true
    },

    conversionTypeTo: {
      type: String,
      required: true
    },

    conversionRate: {
      type: Number,
      required: true
    },

    conversionDuration: {
      type: Number,
      required: true
    }
  }
})
</script>

<style lang="scss" scoped>
$types: ('rare', 'epic');
.gallery-converter {
  @each $type in $types {
    &.#{$type} {
      .gallery-converter-info {
        width: 56.125rem;
        height: 10.875rem;
        @include background(url('#{$path-gallery}converter/converter-box-#{$type}.avif'), contain);
        padding-bottom: 1rem;
        
        &-divider {
          width: 0.125rem;
          height: 7.5rem;
          @include background(
            url('#{$path-gallery}converter/converter-divider-#{$type}.avif'),
            contain
          );
        }
      }
    }
  }

  &-info {
    .info-wrapper {
      width: 45%;
    }
    .info-box {
      width: 16.25rem;
      height: 4rem;
      border-style: solid;
      border-width: 0.125rem;
      border-image-slice: 1;
      @if $isSsm {
        background-color: #363e5d;
        border-image-source: linear-gradient(to top, #fff284, #f6c717);
        box-shadow:
          inset -0.188rem 0 2.5rem 0 rgba(6, 34, 55, 0.48),
          inset -0.0188rem -0.188rem 2.5rem 0 rgba(6, 34, 55, 0.48);
      }
      @if $isWsm {
        background-color: #0f3251;
        border-image-source: linear-gradient(to top, #fff284, #f6c717);
        box-shadow:
          inset -0.188rem 0 2.5rem 0 rgba(51, 123, 214, 0.19),
          inset -0.0188rem -0.188rem 2.5rem 0 rgba(6, 34, 55, 0.48);
      }
    }
  }
}
</style>
